import React from 'react';
import { ToastContainer } from 'react-toastify';
import { Outlet } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ErrorBoundary } from '@sentry/react';
import { Provider } from 'react-redux';
import { AppProvider } from '@querodelivery/uni-react';
import { store } from '@/_store/store';
import { VERSION } from './Constants';

import './Styles/global.scss';
import './Styles/global-mobile.scss';
import './Styles/global-tablet.scss';

import 'semantic-ui-css/semantic.min.css';

import { queryClient } from '@/_config/lib/react-query/query-client';
import { DialogContainer } from '@/Components/util/dialog-container/DialogContainer';
import { ErrorFallback } from '@/Components/util/error-fallback/ErrorFallback';

function AppSetup() {
  return (
    <AppProvider>
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <ErrorBoundary
              // TODO fix lint error
              // eslint-disable-next-line react/no-unstable-nested-components
              fallback={({ ...props }) => (
                <ErrorFallback {...props} fullScreen />
              )}
            >
              <Outlet />
            </ErrorBoundary>
            <ToastContainer
              autoClose={5000}
              hideProgressBar
              closeButton={false}
              closeOnClick
            />

            <DialogContainer />
            <div id="version-number">{VERSION}</div>

            <ReactQueryDevtools initialIsOpen={false} />
          </Provider>
        </QueryClientProvider>
      </React.StrictMode>
    </AppProvider>
  );
}

export { AppSetup };
